import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isAuthenticated = false;
  
  constructor(private router: Router) {
    // Carica lo stato di autenticazione dal localStorage all'avvio
    this.loadAuthState();
  }

  // Carica lo stato di autenticazione dal localStorage
  private loadAuthState(): void {
    const savedAuth = localStorage.getItem('isAuthenticated');
    if (savedAuth === 'true') {
      this.isAuthenticated = true;
    }
  }

  // Salva lo stato di autenticazione nel localStorage
  private saveAuthState(): void {
    localStorage.setItem('isAuthenticated', this.isAuthenticated.toString());
  }

  login() {
    this.isAuthenticated = true;
    this.saveAuthState(); // Salva nel localStorage
    // this.router.navigateByUrl('/tool', { replaceUrl: true });
    console.log('login');
  }
  
  logout() {
    this.isAuthenticated = false;
    this.saveAuthState(); // Salva nel localStorage
    // this.router.navigateByUrl('/login', { replaceUrl: true });
    console.log('logout');
  }

}
